<template>
  <router-view v-wechat-title="$route.meta.title" />
</template>

<script>
import global from '@/assets/js/global' // 全局变量
import tool from '@/assets/js/tool' // 全局函数
import {  monitor } from '@/assets/js/common'
// 使用全局变量
import { useGlobalStore } from '@/assets/js/globalStore'
export default {
    name: 'App',
    components: {
    },
    setup() {
        // 初始化会员的登录状态；刷新后优先从缓存与会员令牌恢复
        const isLogin = tool().resolveLoginState()
        global.isLogin = isLogin

        const globalStore = useGlobalStore()
        globalStore.setLogin(isLogin)

        return {
            isLogin
        }
    },
    data() {
        return {
            // 调试模式
            debug: false,
            // 心跳机制
            heartbeatInterval: 5000, // 5秒发一次心跳
            heartbeatTimeout: 15000, // 15秒没收到消息就认为超时（比心跳间隔多20秒容错）
            heartbeatTimer: null, // 心跳发送定时器
            timeoutTimer: null, // 超时检测定时器
            lastMessageTime: 0, // 最后一次收到消息的时间
            // Ws数据监听
            time: 100,  // 十分之一秒，监听一下WS有没有数据推过来
            timeWs: null,  // 存放时钟的对象
            wsOk: 0, // ws 链接是否已经建立
        }
    },
    mounted() {
        // 判断是否是手机端
        // 如果要用电脑端打开移动端来调试效果 可以先行注释掉本代码块
        if(!this._isMobile()){
            // 因为每次一个用户第一次访问这个网址时，都会运行到这个逻辑判断。
            // 所以，如果用户第一次访问，就是要进入带邀请码的页面，就不要进行跳转，直接用用户指定的 URL 打开页面。

            const fullSuffix = window.location.pathname + window.location.search;
            // console.log("纯原生获取的后缀是:", fullSuffix); // 加上这行排查问题 排除后缀为 /computer 的页面
            if(fullSuffix.includes('/computer') || fullSuffix.includes('/m')){ // 如果已经不是第一次访问，会有前缀 /computer 或 /m 或 /c，这时候就不需要再跳转了。
                return
            }
            // 不是手机端则跳转到PC端
            this.$router.replace("/computer")
        }

        
        // 先全程使用 PC 版本
        // this.$router.replace("/computer")

        tool().NoZooming() // 禁止页面放大
        document.addEventListener('visibilitychange',() => { //浏览器tab标签切换事件
            if(document.visibilityState == 'hidden' ) { //页面切换或者最小化
                // 当页面切换或者最小化时，在此做其他方法操作，
            }
            if (document.visibilityState === 'visible') {
                if (!global.isBind && 1!==global.wssConnection.readyState) {
                    location.reload() // 如果计算机休眠 WS会断开 只能重新加载本页面
                }
            }
        })
    },
    methods:{
        // 判断是否是移动端
        _isMobile(){
            return navigator.userAgent.match(/(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i)
        }
    },
    created() {

        // 用唯一ID标识每次启动的wsUpData实例
        let wsUpDataId = 0
        let currentWsUpDataId = 0
        
        // 实时监听WS推送过来的初始数据
        const wsUpData = (myId) => {
            // 如果不是当前ID，停止执行
            if (myId !== currentWsUpDataId) {
                if (this.debug) console.log(`🛑 旧的 wsUpData (${myId}) 被停止`)
                return
            }
            
            this.timeWs = setTimeout(() => {
                // 再次检查ID，确保没有被新的实例替换
                if (myId !== currentWsUpDataId) {
                    if (this.debug) console.log(`🛑 旧的 wsUpData (${myId}) 在timeout中被停止`)
                    return
                }
                if (false!==global.response && 'ok'===global.response.event ) {
                    if (this.debug) console.log(`ok 已经得到链接成功的响应 ${global.response.data.id}`) 
                    global.wssConID = global.response.data.id
                    global.wssConnection.send( // 我要在 WS 完成链接之后才发起绑定
                        JSON.stringify({'event': 'bind', 'account': global.token, 'id':global.wssConID})
                    )
                    global.response = false
                } 
                // 绑定请求成功后的处理函数
                if (false!==global.response && 'bind'===global.response.event) {
                    if (0===global.response.data.code) success(global.response.data)
                    global.response = false
                } 
                if (false!==global.response && 'ping'===global.response.event ) {
                    if (this.debug) console.log('收到心跳响应')
                    global.response = false
                } 
                wsUpData(myId) // 递归继续，传递相同的ID
            }, this.time)
        }
        
        // 启动wsUpData
        const startWsUpData = () => {
            // 生成新ID并启动
            wsUpDataId++
            currentWsUpDataId = wsUpDataId
            if (this.debug) console.log(`🚀 启动新的 wsUpData (${currentWsUpDataId})`)
            wsUpData(currentWsUpDataId)
        }
        
        // 停止wsUpData
        const stopWsUpData = () => {
            if (this.debug) console.log(`🛑 停止 wsUpData (当前ID: ${currentWsUpDataId})`)
            // 通过改变当前ID来停止所有旧实例
            currentWsUpDataId = -1
            clearTimeout(this.timeWs)
        }

        // 向 WS 发送绑定请求成功后的处理函数
        // @param {*} res WS 响应的登录状态
        const success = (res) => { 
            // 第一时间设置绑定状态
            global.isBind = true
            if (this.debug) console.log('✅ 绑定成功！启动心跳机制...')
            if (this.debug) console.log('   - lastMessageTime:', this.lastMessageTime)
            if (this.debug) console.log('   - 距离现在:', Date.now() - this.lastMessageTime, 'ms')
            // 初始化监听全局变量的对象
            const globalStore = useGlobalStore()
            const isLogin = tool().resolveLoginState(res.login)
            localStorage.setItem('isLogin', String(isLogin))
            global.isLogin = isLogin
            globalStore.setLogin(isLogin)
            // 绑定成功后启动心跳
            startHeartbeat()
            startTimeoutCheck()
            if (this.debug) console.log('   - 心跳和超时检测已启动')
        }

        // 启动心跳发送定时器
        const startHeartbeat = () => {
            // 清除旧的定时器
            clearInterval(this.heartbeatTimer)
            
            // 每隔一定时间发送心跳
            this.heartbeatTimer = setInterval(() => {
                if (global.wssConnection.readyState === 1 && global.isBind) {
                    if (this.debug) console.log('发送心跳 ping')
                    global.wssConnection.send(
                        JSON.stringify({'event': 'ping', 'id': global.wssConID})
                    )
                }
            }, this.heartbeatInterval)
        }
      
        // 启动超时检测定时器
        const startTimeoutCheck = () => {
            // 清除旧的定时器
            clearInterval(this.timeoutTimer)
            
            if (this.debug) console.log('🔍 启动超时检测，超时阈值:', this.heartbeatTimeout, 'ms')
            
            // 每隔一定时间检查是否超时
            this.timeoutTimer = setInterval(() => {
                const now = Date.now()
                const timeSinceLastMessage = now - this.lastMessageTime
                
                if (this.debug) console.log('🔍 检查超时：距离上次消息', timeSinceLastMessage, 'ms')
                
                if (timeSinceLastMessage > this.heartbeatTimeout) {
                    if (this.debug) console.log(`❌ 超时：${timeSinceLastMessage}ms 没有收到消息，关闭连接`)
                    clearInterval(this.heartbeatTimer)
                    clearInterval(this.timeoutTimer)
                    // 超时关闭，会触发重连（因为可能是网络问题）
                    global.wssConnection.close()
                }
            }, 5000) // 每5秒检查一次
        }
      
        // 停止所有定时器
        const stopHeartbeat = () => {
            clearInterval(this.heartbeatTimer)
            clearInterval(this.timeoutTimer)
        }

        // 初时化时，如果客户端没有令牌，会生成一个游客令牌。但是如果缓存中有令牌，即会员已经登录后的令牌，则使用会员的令牌，这是其一。
        // 但是，如果用户是从游客切换到会员登录状态的，这个令牌怎么切换呢？
        const initWs = () => {
            if (this.debug) console.log('🚀🔧 initWs 被调用')
                        
            // 先停止所有定时器，避免累积
            stopHeartbeat()
            stopWsUpData()
            
            // 关键修复：先关闭旧的 WebSocket 连接
            if (global.wssConnection && global.wssConnection.readyState !== WebSocket.CLOSED) {
                // console.log('🔌 关闭旧连接，readyState:', global.wssConnection.readyState)
                try {
                    // 移除旧连接的事件监听，避免触发 onclose 重连
                    global.wssConnection.onclose = null
                    global.wssConnection.onerror = null
                    global.wssConnection.onmessage = null
                    global.wssConnection.close()
                } catch(e) {
                    console.error('关闭旧连接失败:', e)
                }
            }
            
            if (this.debug) console.log( `WS 初始化时的 token ： ${localStorage.getItem('token')}` ) 
            // Uncaught (in promise) TypeError: Cannot read properties of null (reading 'length')
            // 第一次时 localStorage.getItem('token') 是不存在的 不存在就不可以合用 length 属性
            global.token = (localStorage.getItem('token') && 30 >= localStorage.getItem('token').length) ?  tool().getUuidRadar()  : localStorage.getItem('token')

            // 请求链接WS服务器
            global.wssConnection = new WebSocket(global.wss)
            
            // 启动数据监听
            startWsUpData()

            // 链接成功的回调函数：链接一旦创建成功，会得到 event = ok 的推送数据
            global.wssConnection.onopen = () => {
                
                // 链接成功 把客户端令牌缓存起来
                localStorage.setItem('token', global.token)
                if (this.debug) console.log('✅ WS 成功链接，account:', global.token)
                // console.trace('onopen 调用栈：')
                // 更新最后消息时间
                this.lastMessageTime = Date.now()
                // 连接成功后立即发送绑定请求
                // console.log('📤 发送绑定请求...')
            }

            // 收到信息的回调函数 
            global.wssConnection.onmessage = (event) => {
                // 更新最后收到消息的时间
                this.lastMessageTime = Date.now()
                // 处理消息
                monitor(JSON.parse(event.data))
                if (this.debug) console.log(`收到事件 event 的响应：${JSON.parse(event.data).event}   收到的时间：${this.lastMessageTime} 距离现在：${Date.now() - this.lastMessageTime}ms`)
            }

            // 链接断开的回调函数
            global.wssConnection.onclose = (event) => {
                if (this.debug) console.log('❌ WS 链接被断开')
                if (this.debug) console.log('   - code:', event.code)
                if (this.debug) console.log('   - reason:', event.reason)
                if (this.debug) console.log('   - isBind:', global.isBind)
                if (this.debug) console.log('   - lastMessageTime:', this.lastMessageTime)
                if (this.debug) console.log('   - 距离现在:', Date.now() - this.lastMessageTime, 'ms')
                
                global.isBind = false
                // 停止心跳
                stopHeartbeat()
                
                // 如果是正常关闭或被服务器主动关闭，不重连
                // code 1000: 正常关闭
                // code 1001: 服务器关闭或页面离开
                // code 1006: 异常断开（网络问题）
                // 最终我不是决定把这断去掉，因为我要测试，手动断开网络后，我要看它自动重连。
                // if (event.code === 1000 || event.code === 1001) {
                //     console.log('⏹️ 连接被正常关闭，不重连')
                //     return
                // }
                
                // 只有网络异常等情况才重连
                setTimeout(() => {
                    if (this.debug) console.log('🔄 尝试重新连接 WS...')
                    initWs()
                }, 3000)
            }
        }
        
        // 初始化 WebSocket 链接
        initWs()

        return {
            startHeartbeat,
            stopHeartbeat,
            initWs
        }
    },
    beforeUnmount () {
        clearInterval(this.heartbeatTimer)
        clearInterval(this.timeoutTimer)
        // 注意：不需要手动清除 timeWs，因为 stopWsUpData 会处理
    }
}
</script>

<style lang="scss" scoped>

</style>
